import {
  LEGALPEIL_LOADING,
  GET_LEGALPEIL,
  GET_LEGALPEIL_SUCCESS,
  GET_LEGALPEIL_FAIL,
  ADD_LEGALPEIL_SUCCESS,
  ADD_LEGALPEIL_FAIL,
  DELETE_LEGALPEIL_SUCCESS,
  DELETE_LEGALPEIL_FAIL,
  UPDATE_LEGALPEIL_SUCCESS,
  UPDATE_LEGALPEIL_FAIL,
  LEGALPEIL_RESET
} from "./actionType";

const INIT_STATE = {
  legalPeils: [],
  error: {},
};

const LegalPeil = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LEGALPEIL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_LEGALPEIL:
          return {
            ...state,
            legalPeils: action.payload.data,
            isLegalPeilCreated: false,
            isLegalPeilSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_LEGALPEIL_FAIL:
      switch (action.payload.actionType) {
        case GET_LEGALPEIL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isLegalPeilCreated: false,
            isLegalPeilSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_LEGALPEIL: {
      return {
        ...state,
        isLegalPeilCreated: false,
        loading: true,
      };
    }

    case LEGALPEIL_LOADING: {
      return {
        ...state,
        isLegalPeilCreated: false,
        loading: true,
      };
    }

    case ADD_LEGALPEIL_SUCCESS:
      return {
        ...state,
        isLegalPeilCreated: true,
        loading: false,
        legalPeils: [action.payload.data, ...state.legalPeils],
      };

    case ADD_LEGALPEIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_LEGALPEIL_SUCCESS:
      return {
        ...state,
        loading: false,
        legalPeils: state.legalPeils.filter(
          legalPeil => legalPeil.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_LEGALPEIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_LEGALPEIL_SUCCESS:
      return {
        ...state,
        loading: false,
        legalPeils: state.legalPeils.map(legalPeil =>
          legalPeil.id.toString() === action.payload.data.id.toString() ? { ...legalPeil, ...action.payload.data } : legalPeil
        ),
      };

    case UPDATE_LEGALPEIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case LEGALPEIL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default LegalPeil;